import React from 'react';
import ContactUsPage from '../components/home/contactuspage';
import ContactUsPageForm from '../components/home/contactuspageform';
import DesireTechSection from '../components/home/DesireTechSection';
import TestimonialsSection from '../components/home/TestimonialsSection';

const ContactUs = () => {
    return (
        <div className="contact-page-container">
            <ContactUsPage />
            <ContactUsPageForm />
            <DesireTechSection
                title={<><span style={{ color: '#54b248' }}>Grow your business with</span> a powerful online presence.</>}
                subtitle="We’ll work on taking your website to the next level with the best techniques and technologies. So it has the best features and looks the part."
                buttonText="Schedule a Meeting"
                variant="contactus"
            />
            <TestimonialsSection />
            <div className="contact-placeholder" style={{ display: 'none' }}>

            </div>
        </div>
    );
};

export default ContactUs;
